function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';

var Events =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Events, _React$Component);

  function Events(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.listeners = [];

    _this.addEvent = function (el, name, fn) {
      _this.listeners.push([el, name, fn]);

      el.addEventListener(name, fn);
    };

    _this.removeEvent = function (el, name, fn) {
      el.removeEventListener(name, fn);

      for (var x = 0; x < _this.listeners.length; x++) {
        var event = _this.listeners[x];
        var el_ = event[0],
            name_ = event[1],
            fn_ = event[2];

        if (el === el_ && name === name_ && fn === fn_) {
          _this.listeners.splice(x, 1);
        }
      }
    };

    _this.removeAllEvents = function (el) {
      for (var x = 0; x < _this.listeners.length; x++) {
        var _this$listeners$x = _this.listeners[x],
            el_ = _this$listeners$x[0],
            name = _this$listeners$x[1],
            fn = _this$listeners$x[2];

        if (!el || el_ === el) {
          el_.removeEventListener(name, fn);

          _this.listeners.splice(x, 1);
        }
      }
    };

    _this.renderProps = {
      addEvent: _this.addEvent,
      removeEvent: _this.removeEvent,
      removeAllEvents: _this.removeAllEvents
    };
    return _this;
  }

  var _proto = Events.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.removeAllEvents();
  };

  _proto.render = function render() {
    return this.props.children(this.renderProps);
  };

  return Events;
}(React.Component);

export { Events as default };
Events.propTypes = {
  children: PropTypes.func.isRequired
};